<template xmlns="http://www.w3.org/1999/html">
  <section class="custom_page  funnel_page" style="">


    <card type="secondary" style="" shadow  v-if="is_load"
          header-classes="bg-white pb-5"
          body-classes=""
          class="border-0 funnel_card">
      <div class="container-fluid">
        <div class="row">

          <div class="col-lg-12">

            <sui-breadcrumb v-if="project.main_project_id>0 && project.main_project.last_id">
              <sui-breadcrumb-section @click="openTask(project.main_project.last_id)" link
                                      v-html="project.main_project.name_project"></sui-breadcrumb-section>
              <sui-breadcrumb-divider icon="right chevron"/>

              <sui-breadcrumb-section active
              >{{ project.name_project }}
              </sui-breadcrumb-section
              >
            </sui-breadcrumb>


            <sui-step-group size="mini" v-if="project.main_project_id==0">
              <a is="sui-step" :active="project.status_row.issearch==1" icon="shopping cart">
                <sui-step-content
                    title="Поиск исполнителя"
                    description="Выберите исполнителя который вам понравился :)"

                />
              </a>

              <a is="sui-step" :active="project.status_row.iswork==1" icon="handshake outline">
                <sui-step-content
                    title="Проект в работе"
                    description="Плодотворная работа в самом разгаре"
                />
              </a>
              <a is="sui-step" :active="project.status_row.isfinish==1" icon="thumbs up outline">
                <sui-step-content
                    title="Проект завершен"
                    description="Проект завершен, радуйтесь и пляшите"
                />
              </a>
            </sui-step-group>
          </div>
        </div>
        <div style="position: relative">
          <base-nav type="default" effect="dark" expand>
          <a class="navbar-brand" href="#">{{ project.name_project}}</a>

          <div class="row" slot="content-header" slot-scope="{closeMenu}">
            <div class="col-6 collapse-brand">
              <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
                {{ project.name_project}}
              </a>
            </div>
            <div class="col-6 collapse-close">
              <close-button @click="closeMenu"></close-button>
            </div>
          </div>




          <ul class="navbar-nav ml-lg-auto">







         <li class="nav-item">
            <form class="form-inline my-2 my-lg-0">
              <select class="form-control" @change="setNewStatus" v-model="project.status"
                      v-if="project.statuses.length>0 && (type!='spectator' || (project.main_project && project.main_project.manage_spectator==1)) && project.developer_id>0">
                <option v-for="status in project.statuses"
                        :value="status.last_id" :key="status.last_id">
                  {{ status.title }}

                </option>

              </select>
            </form>
         </li>
          </ul>
        </base-nav>
        </div>
        <div class="row  ">


<!--          <div class="col-lg-3 order-lg-2">-->
<!--            <div class="card-profile-image">-->
<!--              <a href="#" v-if="project.client.avatar">-->
<!--                <img :src="image_url+project.client.avatar" class="rounded-circle">-->
<!--              </a>-->
<!--              <a href="#" v-if="project.client.avatar==null">-->
<!--                <avatar :username="project.client.name" size="150" class="rounded-circle"></avatar>-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
          <div class="col-lg-7 order-lg-3 text-lg-right align-self-lg-center">
            <div class="card-profile-actions py-4 mt-lg-0">

              <div v-if="(type=='developer' || type=='client' || type=='spectator') && project.invoices.length>0">

                <modal modal-classes="modal-lg" :show.sync="modals.modal_pj_invoices">
                  <template slot="header">
                    <h5 class="modal-title" id="exampleModalLabel">Счета</h5>
                  </template>
                  <div class="" v-if="project.invoices.length>0">


                    <div class=" row mt-2" v-for="(project_invoice,index) in project.invoices"
                         :key="project_invoice.last_id">
                      <div class="col-md-2">@{{ users['last_id_' + project_invoice.client_id].name }} <i
                          class="fa fa-arrow-right"></i>
                        @{{ users['last_id_' + project_invoice.developer_id].name }}
                      </div>

                      <div class="col-md-3">
                        {{ project_invoice.sum }} {{ project_invoice.currency }}
                      </div>
                      <div class="col-md-3">
                        {{ project_invoice.title }}


                      </div>

                      <div class="col-md-2">


                        <badge pill v-if="project_invoice.final!=null && project_invoice.final.ispay!=1"
                               type="warning">ожидает оплаты
                        </badge>
                        <badge pill
                               v-if="project_invoice.is_approve_client==0 && me.last_id==project_invoice.developer_id"
                               type="warning">не утвержден
                        </badge>
                        <badge pill
                               v-if="project_invoice.is_approve_client==1 && me.last_id==project_invoice.developer_id"
                               type="success"> утвержден
                        </badge>

                        <base-button type="primary"
                                     v-if="project_invoice.is_approve_client==0 && project_invoice.client_id==me.last_id"
                                     @click="approveInvoice($event,index)">Подтвердить
                        </base-button>
                        <base-button type="primary"
                                     v-if="project_invoice.is_approve_client==1 && project_invoice.is_finish==0 && project_invoice.client_id==me.last_id"
                                     @click="completeInvoice($event,index)">Все сделано
                        </base-button>

                        <base-button type="primary"
                                     v-if="project_invoice.is_approve_client==0 && project_invoice.developer_id==me.last_id"
                                     @click="removeInvoice($event,project_invoice.last_id)"><i
                            class="fa fa-remove"></i></base-button>
                      </div>
                    </div>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal_pj_invoices = false">Закрыть</base-button>

                  </template>
                </modal>

              </div>

              <div class="h6 font-weight-300"
                   v-if="(project.developer_id==me.last_id ) && project.main_project_id=='0'">



                <modal :show.sync="modals.modal0" v-if="type=='developer'">
                  <template slot="header">
                    <h5 class="modal-title" id="exampleModalLabel2">Добавить счет</h5>
                  </template>
                  <div>
                    <div class="alert alert-danger" v-if="new_invoice_iserror==true">
                      <p>{{ new_invoice_error }}</p>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-5">
                        <label for="exampleUser">Пользователь </label>
                        <select id="exampleUser" v-if="is_load==true" required v-model="newInvoice.user_id"
                                class="form-control">
                          <option v-if="user.last_id!=me.last_id || (user.role=='spectator' && user.isapprove==0)"
                                  v-for="user in users" :value="user.last_id"
                                  :key="user.last_id">@{{
                              user.name
                            }}
                          </option>

                        </select>


                      </div>
                      <div class="form-group col-md-5">
                        <label for="exampleTypeInvoice">Тип </label>
                        <select id="exampleTypeInvoice" v-if="is_load==true" required
                                class="form-control" v-model="newInvoice.type">
                          <option value="client" v-if="newInvoice.user_id==project.client_id">
                            должен
                            оплатить
                          </option>
                          <option value="developer" v-if="newInvoice.user_id!=project.client_id">
                            должен получить
                          </option>
                        </select>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-5">
                        <label for="exampleSum">Сумма </label>
                        <input type="text" class="form-control" required id="exampleSum" v-model="newInvoice.sum"
                               placeholder="Введите сумму">

                      </div>
                      <div class="form-group col-md-5">
                        <label for="exampleCurrency5">Валюта </label>
                        <select id="exampleCurrency5" v-if="is_load==true" required
                                class="form-control" v-model="newInvoice.currency">
                          <option value="RUB">RUB</option>
                          <option value="USD">USD</option>
                          <option value="EURO">EURO</option>
                        </select>


                      </div>
                    </div>
                    <div class="row">
                      <label for="exampleTitle5">Описание услуги </label>
                      <input type="text" class="form-control" required id="exampleTitle5" v-model="newInvoice.title"
                             placeholder="Введите описание">
                    </div>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal0 = false">Закрыть</base-button>
                    <base-button type="primary" @click="addInvoice()">Создать счет</base-button>
                  </template>
                </modal>
              </div>
              <div class="h6 font-weight-300 mt-2">
                <h3 v-if="type=='spectator' && !(project.main_project && project.main_project.manage_spectator==1)">{{ project.status_row.title }}</h3>



              </div>

            </div>
          </div>
          <div class="col-lg-4 order-lg-1">


            <div class="h6 font-weight-300" v-if="project.status_row.issearch==0 && type!='spectator'">
              <div>

                <modal :show.sync="modals.users">
                  <template slot="header">
                    <h5 class="modal-title">Список участников</h5>
                  </template>
                  <div>

                    <sui-card-group :items-per-row="2">
                      <sui-card v-for="user_project in users" :key="user_project.last_id">
                        <sui-card-content>
                          <avatar v-if="user_project.avatar==null" :size="187" :username="user_project.name"
                                  class="right floated ui image"></avatar>
                          <sui-image v-if="user_project.avatar"
                                     :src="image_url+user_project.avatar"
                                     class="right floated"
                          />
                          <sui-card-header>{{ user_project.name }}</sui-card-header>
                          <sui-card-meta v-if="user_project.role=='client'">Клиент</sui-card-meta>
                          <sui-card-meta v-if="user_project.role=='developer'">Исполнитель
                          </sui-card-meta>
                          <sui-card-meta
                              v-if="user_project.role=='spectator'">
                            Наблюдатель
                          </sui-card-meta>
                          <sui-card-description v-if="user_project.role=='spectator' && user_project.isapprove==0">
                            Еще не принял приглашение!
                          </sui-card-description>
                        </sui-card-content>
                        <sui-card-content extra>
                          <sui-container text-align="center">
                            <sui-button-group v-if="user_project.role=='spectator'">

                              <sui-button @click="deleteSpectator(user_project.last_id)" basic negative>Удалить
                              </sui-button>
                            </sui-button-group>
                          </sui-container>
                        </sui-card-content>
                      </sui-card>

                    </sui-card-group>

                    <div class="mt-5 alert alert-danger" v-if="invite_user_is_error==true">
                      <p>{{ invite_user_message }}</p>
                    </div>


                    <div class="row alert alert-warning" v-if="project.invites.length>0" v-for="invite in project.invites" :key="invite.id">
                      <div class="col-md-8">
                        <blockquote>{{base_url}}#/invite/{{invite.project_id}}/{{ invite.code}}</blockquote>
                        <br>
                        Осталось:{{invite.count}}
                      </div>
                      <div class="col-md-4">
                        <button class="btn btn-danger" @click="deleteInviteLink(invite.id)">Удалить</button>
                      </div>
                    </div>

                    <div class="row mt-5">
                      <div class="form-group col-md-6">
                        <label for="exampleUsername22">Количество </label>
                        <input type="number" class="form-control" required id="exampleUsername22" v-model="count_invites"
                               placeholder="Количество">
                      </div>
                      <div class="form-group col-md-6">  <button class=" btn btn-success" @click="createInviteLink()">Создать ссылку</button></div>

                    </div>

                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.users = false">Закрыть</base-button>

                  </template>
                </modal>

              </div>
            </div>

          </div>
        </div>
        <div class="text-center mt-5">


        </div>
        <div class="mt-5 py-5 border-top text-center">

        </div>
      </div>
      <div class="container-fluid">



        <div class="row">

<div class="col-lg-10 ">
  <nav class="nav">
    <button class="btn side2 nav-link" v-if="project.main_project_id==0"   @click="openCurrentPageProject">Проект</button>
    <button class="btn side2 nav-link " v-if="project.main_project_id>0"   @click="openCurrentPageProject">Задача</button>
    <button class="btn side2 nav-link" v-if="project.main_project_id==0"  @click="openCurrentPageMap">Карта</button>
    <button class="btn side2 nav-link" v-if="project.main_project_id==0"  @click="openCurrentPageCanban">Канбан-Доска</button>
    <button class="btn side2 nav-link" v-if="project.main_project_id==0"  @click="openCurrentPageTasks">Все задачи</button>
  </nav>
  <card v-if="current_page=='project'">

  <editorjsrender :blocks_json="project.json.blocks"></editorjsrender>
  <div class="row ml-2 mt-5"
       v-if="(project.client_id==me.last_id || (project.status_row.issearch==0 && type=='developer')) && !(project.main_project && project.main_project.manage_spectator==1)">
    <button class="btn side4" v-if="project.main_project_id==0" @click="editProjectClick">Редактировать проект</button>
    <button class="btn side4" v-if="project.main_project_id>0" @click="editProjectClick">Редактировать задачу</button>

  </div>
    <div class="row ml-2 mt-5"
         v-if="project.main_project && project.main_project.manage_spectator==1 ">

      <button class="btn side4" v-if="project.main_project_id>0" @click="editProjectShareClick">Редактировать задачу</button>

    </div>

  </card>
  <div class="row-grid ml-2 mt-5" v-if="current_page=='map'">
    <div class="col-md-12 center-block"  >
      <h2>Карта сайта</h2>
      <vue-suggestion placeholder="Введите запрос для поиска задачи" inputClasses="form-control" :items="map_items"
                      v-model="map_item"
                      :setLabel="setMapLabel"
                      :itemTemplate="itemTemplate"
                      @changed="inputMapChange"
                      @selected="itemMapSelected">
      </vue-suggestion>
      <div class="row col-lg-12">
        <div class="col-12 col-lg-3">
          <p v-if="!(map_current_task && map_current_task.id)">выберите задачу</p>
          <p v-if="(map_current_task && map_current_task.id)">{{ map_current_task.name}}</p>
        </div>
        <div class="col-12 col-lg-6">
          <textarea v-model="map_current_descr" placeholder="введите описание"></textarea>
        </div>
        <div class="col-12 col-lg-3">
          <button class="btn btn-success" v-if="map_current_descr.length>0 && map_current_task && map_current_task.id" @click="addTaskOnMap">Добавить</button>
        </div>
      </div>



      <simple-flowchart     :scene.sync="data_map"></simple-flowchart>
      <div class="row">
        <div class="col-12 col-lg-4 mt-4">
          <button class="btn side4" @click="saveMap">Сохранить карту</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row-grid ml-2 mt-5" v-if="current_page=='tasks'">
    <card type="secondary" shadow
          header-classes="bg-white pb-5"
          body-classes=""
          class="border-0">

      <div class="col-md-12 center-block" v-if="is_load_tasks==false">
        <sui-segment>
          <sui-dimmer active>
            <sui-loader size="tiny"></sui-loader>
          </sui-dimmer>


        </sui-segment>
      </div>


      <div class="col-md-12 center-block" v-if="is_load_tasks==true">

        <div class="row mt-5 mb-5">
          <div class="col-md-5">
            <input type="text" class="form-control" placeholder="Введите для поиска" @change="changeFilterTasks" v-model="filter_tasks.q"/>
          </div>
          <div class="col-md-5">
            <select class="form-control" @change="changeFilterTasks" v-model="filter_tasks_current_status">
              <option :value="null">Показать все</option>
              <option v-if="project.statuses.length>0" v-for="status in project.statuses" :value="status.last_id"
                      :key="status.last_id">{{
                  status.title
                }}
              </option>
            </select>
          </div>
        </div>



        <div class="col-lg-12" v-if="tasks.length>0">

          <div class="row mt-2"
               v-if="(filter_tasks_current_status==null || (filter_tasks_current_status!=null && task.status==filter_tasks_current_status)) && task_index>=(((tasks_table.current_page*tasks_table.on_page)-tasks_table.on_page)-1) && task_index<=((tasks_table.current_page*tasks_table.on_page)-1)"
               v-for="(task,task_index) in tasks" :key="task.last_id">
            <div class="col-lg-7 text-truncate">
              <router-link class="text-clip" :to="{name: 'project', params: { id: task.last_id }}">


                <base-button type="primary" class="text-clip" v-html="task.name_project">


                </base-button>
              </router-link>
            </div>
            <div class="col-lg-3">

              <badge pill type="info" v-if="task.status_row.issearch==1">{{ task.status_row.title }}</badge>
              <badge pill type="warning" v-if="task.status_row.iswork==1">{{ task.status_row.title }}
              </badge>
              <badge pill type="success" v-if="task.status_row.isfinish==1">{{ task.status_row.title }}
              </badge>
            </div>
            <div class="col-lg-2">
              <router-link :to="{name: 'project', params: { id: task.last_id }}"
                           class="mb-3 mb-sm-0 btn btn-danger">
                <i
                    class="ni ni-bold-right"></i>
              </router-link>

            </div>


          </div>


          <div class="row mt-2">
            <base-pagination :per-page="tasks_table.on_page" :total="tasks_table.total"
                             v-model="tasks_table.current_page"></base-pagination>
          </div>


        </div>

      </div>
    </card>
  </div>
  <div class="row-grid  ml-2 mt-5" v-if="current_page=='canban'">

    <h2> Канбан-доска</h2>



    <div class="row">
      <div class="col-lg-12 row">

        <div class="row col-lg-6">


          <input type="text" class="m-2 form-control" placeholder="Введите для поиска"  v-model="searchfields['q']"/>

        </div>
        <div class="row col-lg-6">
          <select class="m-2 form-control"  v-model="searchfields['_type']">
            <option value="null">Выберите тип</option>
            <option value="projects">Проекты</option>
            <option value="tasks">Задачи</option>
            <option value="all">Проекты и задачи</option>

          </select>
        </div>
      </div>
      <div  class="col-lg-12 row"    v-if="fields   && fields.length>0">



        <div class="row col-lg-6  form-group"  v-for="field in fields"   :key="field.last_id">
          <div class="col-md-6">
            <label for="exampleCategory">{{ field.title}} </label>
          </div>
          <div class="col-md-6">
            <select  id="exampleCategory" v-if="field.type=='select' || field.type=='selectinsert'" v-model="searchfields[field.name]"

                     class="form-control">
              <option value="null"></option>
              <option v-for="value in field.values" :value="value.last_id" :key="value.last_id">
                {{ value[field.key_title] }}
              </option>

            </select>
            <input class="form-control" type="number" v-if="field.type=='number'" v-model="searchfields[field.name]"/>
            <input class="form-control" type="text" v-if="field.type=='stroka'" v-model="searchfields[field.name]"/>
          </div>






        </div>

      </div>
      <div class="col-lg-12 form-group">
        <base-button   @click="searchFilter()" class="side4">Найти</base-button>

        <button class="btn side4"  v-if="project.status_row.issearch==0 && project.main_project_id==0 && (type!='spectator' || (  project.manage_spectator==1 && project.main_project_id==0)) " @click="addTaskClick">Добавить задачу</button>


      </div>


    </div>


    <div class="row" v-if="stages.length>0">

      <kanban-board  @update-block="updateBlock" :stages="stages" :blocks="blocks"> <div v-for="stage in stages" :slot="stage" :key="stage" >
        <h2>{{ stage }}</h2>
      </div>

        <sui-card class="lead_mini" style="" v-for="block in blocks" :slot="block.id" :key="block.id" >

          <sui-card-content class="lead_info " style="padding-left:10%;min-height:170px;">

            <sui-card-header style="overflow:hidden;text-overflow: ellipsis;height:5em;" @click="openProject(block.id)"  v-if="block.project.name_project && block.project.name_project.length>0">{{ block.project.name_project}}</sui-card-header>

            <sui-card-meta>
              <button class="btn btn-danger" @click="openProject(block.id)">Открыть</button>
            </sui-card-meta>
          </sui-card-content>

        </sui-card>
      </kanban-board>
    </div>






  </div>

</div>
          <div class="col-lg-2 text-center">
            <card>
            <h4>{{ project.name_project}}</h4>


            <ul class="nav navbar flex-column">

              <li class="nav-item nav-item2" v-if="(type=='developer' || type=='client') && project.status_row.issearch==0 && project.manage_spectator==0 && project.main_project_id==0 ">
                <button class="nav-link mb-1 proj_link" @click="changeManageSpectator(1)"  >общий доступ выключен</button>
              </li>
              <li class="nav-item nav-item2" v-if="(type=='developer' || type=='client') && project.status_row.issearch==0 && project.manage_spectator==1 && project.main_project_id==0 ">
                <button class="nav-link mb-1 proj_link" @click="changeManageSpectator(0)" >общий доступ включен</button>
              </li>
              <li class="nav-item nav-item2"  v-if="(project.status_row.issearch==0 && type!='spectator') && !(project.main_project && project.main_project.manage_spectator==1)">
                <button class="nav-link mb-1 btn-danger proj_link" @click="modals.users = true"  >Участники</button>
              </li>
              <li class="nav-item nav-item2" v-if="(type=='developer' || type=='client' || type=='spectator') && project.invoices.length>0">
                <button class="nav-link  mb-1 btn-danger proj_link"  @click="modals.modal_pj_invoices = true"  >Счета       <badge type="white">{{ project.invoices.length }}</badge></button>
              </li>
              <li class="nav-item nav-item2" v-if="(type=='developer' || type=='client' || type=='spectator') && blog_category && blog_category.alias">
                <router-link class="text-clip" tag="a" :to="{name: 'category_blog', params: { alias: blog_category.alias }}">
                  <button type="primary" class="nav-link btn-danger proj_link mb-1"  >
                    База знаний

                  </button>
                </router-link>

              </li>
              <li class="nav-item nav-item2" v-if="type=='developer' && project.main_project_id==0">
                <button class="nav-link btn btn-danger proj_link mb-1"    @click="modals.modal0 = true">Добавить счет</button>
              </li>

              <li class="nav-item nav-item2" v-if="(type=='client' || type=='developer') && project.secretId">
                <button class="nav-link btn btn-danger proj_link mb-1"   @click="modals.modal_integration_telegram = true">Интеграция с TG</button>
              </li>
              <li class="nav-item nav-item2" v-if="( type=='developer') && lead && lead.id">
                <button class="nav-link btn btn-danger proj_link mb-1"   @click="openLead(lead.id)">Лид</button>
              </li>





            </ul>
            </card>
          </div>


<div class="row">
          <div class="col-md-12 center-block mt-5" v-if="project.status_row.issearch==1">
            <sui-comment-group size="massive" threaded>
              <h3 is="sui-header" dividing>Заявки от исполнителей</h3>

              <sui-comment v-for="(offer,offer_index) in project.offers" :key="offer.last_id">
                <sui-comment-avatar v-if="offer.developer.avatar" :src="image_url+offer.developer.avatar"/>
                <div class="avatar" v-if="offer.developer.avatar==null" :src="image_url+offer.developer.avatar">

                  <avatar v-if="offer.developer.avatar==null" :size="35" :username="offer.developer.name"
                          class="rounded-circle"></avatar>

                </div>


                <sui-comment-content>
                  <a is="sui-comment-author">{{ offer.developer.name }}</a>
                  <sui-comment-metadata>
                    <div>{{ offer.created_at }}</div>
                    <div> {{ offer.price }} <strong><i class="fa fa-euro" v-if="offer.currency=='EURO'"></i> <i
                        class="fa fa-ruble"
                        v-if="offer.currency=='RUB'"></i>
                      <i class="fa fa-usd" v-if="offer.currency=='USD'"></i></strong>

                    </div>
                    <div>сроки <i class="fa fa-calendar-times-o"></i>{{ offer.date_end }}</div>
                    <div class="" v-if="me.last_id==project.client_id">
                      <button class="btn btn-primary" @click="ChooseOffer(offer.last_id)">Выбрать исполнителя</button>
                    </div>
                  </sui-comment-metadata>
                  <sui-comment-text>{{ offer.comment }}</sui-comment-text>

                </sui-comment-content>
                <sui-comment-group v-if="me.last_id==offer.developer_id || type=='client'">

                  <sui-comment v-for="(offer_comment,index_offer_comment) in offer.comments"
                               :key="offer_comment.last_id">
                    <sui-comment-avatar v-if="offer_comment.user.avatar" :src="image_url+offer_comment.user.avatar"/>
                    <div class="avatar" v-if="offer_comment.user.avatar==null"
                         :src="image_url+offer_comment.user.avatar">

                      <avatar v-if="offer_comment.user.avatar==null" :size="35" :username="offer_comment.user.name"
                              class="rounded-circle"></avatar>

                    </div>
                    <sui-comment-content>
                      <a is="sui-comment-author">{{ offer_comment.user.name }}</a>
                      <sui-comment-metadata>
                        <div>{{ offer_comment.created_at }}</div>
                      </sui-comment-metadata>
                      <sui-comment-text>
                        {{ offer_comment.comment }}
                      </sui-comment-text>

                    </sui-comment-content>
                  </sui-comment>
                  <sui-comment>
                    <div class="row">
                      <div class="col-md-8">
                        <textarea class="row form-control" v-model="subcomment['offer'+offer.last_id]"></textarea>
                      </div>
                      <div class="col-md-4">
                        <button class="btn btn-success" @click="sendOfferComment(offer.last_id,offer_index)"><i
                            class="fa fa-arrow-circle-right"></i></button>
                      </div>
                    </div>
                  </sui-comment>
                </sui-comment-group>
              </sui-comment>


              <h3 is="sui-header" dividing v-if="me.last_id!=project.client_id">Оставить заявку</h3>
              <div class="alert alert-danger" v-if="new_offer_is_error==true">
                <p>{{ new_offer_error }}</p>
              </div>
              <div class="row " v-if="me.last_id!=project.client_id">
                <div class="form-group col-md-4">
                  <label for="exampleSum">Сумма </label>
                  <input type="text" class="form-control" required id="exampleSum" v-model="newOffer.price"
                         placeholder="Введите сумму">

                </div>
                <div class="form-group col-md-4">
                  <label for="exampleCurrency">Валюта </label>
                  <select id="exampleCurrency" v-if="is_load==true" required
                          class="form-control" v-model="newOffer.currency">
                    <option value="RUB">RUB</option>
                    <option value="USD">USD</option>
                    <option value="EURO">EURO</option>
                  </select>


                </div>
                <div class="form-group col-md-4">
                  <label for="exampleDate">Срок до </label>
                  <input type="date" class="form-control" required id="exampleDate" v-model="newOffer.date_end"
                         placeholder="Укажите дату">

                </div>
              </div>

              <div class="row pt-2 pb-2" v-if="me.last_id!=project.client_id">
                <div class="col-md-8">
                  <label for="exampleTitle">Описание услуги </label>
                  <input type="text" class="form-control" required id="exampleTitle" v-model="newOffer.comment"
                         placeholder="Введите описание">
                </div>
                <div class="col-md-4">
                  <label for="exampleTitle">Заполните все поля :)</label>
                  <button class=" btn btn-success" @click="sendOffer">{{ offer_btn_edit }}</button>
                </div>
              </div>


            </sui-comment-group>
          </div>
</div>

          <div class="row-grid">
          <div class="col-md-12 center-block mt-5" v-if="project.status_row.iswork==1">
            <sui-comment-group size="massive" threaded>
              <h3 is="sui-header" dividing>Комментарии</h3>

              <sui-comment v-for="(comment,comment_index) in project.comments" :key="comment.last_id">
                <sui-comment-avatar v-if="comment.user.avatar" :src="image_url+comment.user.avatar"/>
                <div class="avatar" v-if="comment.user.avatar==null">

                  <avatar v-if="comment.user.avatar==null" :size="35" :username="comment.user.name"
                          class="rounded-circle"></avatar>

                </div>


                <sui-comment-content>
                  <a is="sui-comment-author">{{ comment.user.name }}</a>
                  <sui-comment-metadata>
                    <div>{{ comment.created_at }}</div>


                  </sui-comment-metadata>
                  <sui-comment-text>{{ comment.comment }}</sui-comment-text>

                </sui-comment-content>
                <sui-comment-group>

                  <sui-comment v-for="(subcomment,index_subcomment) in comment.comments"
                               :key="subcomment.last_id">
                    <sui-comment-avatar v-if="subcomment.user.avatar" :src="image_url+subcomment.user.avatar"/>
                    <div class="avatar" v-if="subcomment.user.avatar==null"
                    >

                      <avatar v-if="subcomment.user.avatar==null" :size="35" :username="subcomment.user.name"
                              class="rounded-circle"></avatar>

                    </div>
                    <sui-comment-content>
                      <a is="sui-comment-author">{{ subcomment.user.name }}</a>
                      <sui-comment-metadata>
                        <div>{{ subcomment.created_at }}</div>
                      </sui-comment-metadata>
                      <sui-comment-text>
                        {{ subcomment.comment }}
                      </sui-comment-text>

                    </sui-comment-content>
                  </sui-comment>
                  <sui-comment>
                    <div class="row">
                      <div class="col-md-8">
                          <textarea class="row form-control"
                                    v-model="project_subcomment['comment'+comment.last_id]"></textarea>
                      </div>
                      <div class="col-md-4">
                        <button class="btn btn-success" @click="sendSubComment(comment.last_id,comment_index)"><i
                            class="fa fa-arrow-circle-right"></i></button>
                      </div>
                    </div>
                  </sui-comment>
                </sui-comment-group>
              </sui-comment>


              <h3 is="sui-header" dividing>Написать комментарий</h3>
              <div class="alert alert-danger" v-if="new_comment_is_error==true">
                <p>{{ new_comment_error }}</p>
              </div>


              <div class="row pt-2 pb-2">
                <div class="col-md-8">
                  <label for="exampleTitle">Комментарий </label>
                  <textarea  class="form-control" required id="exampleTitle" v-model="newComment.comment"
                         placeholder="Введите комментарий"></textarea>
                </div>
                <div class="col-md-4">
                  <label for="exampleTitle"></label>
                  <button class=" btn side4" @click="sendComment">Отправить комментарий</button>
                </div>
              </div>


            </sui-comment-group>
          </div>
          </div>
        </div>


      </div>




      <modal modal-classes="modal-lg" :show.sync="modals.modal_integration_telegram">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel5">Интеграция с telegram</h5>
        </template>
        <div class=""  >


          <ul style="text-align: left;">
            <li>Шаг 1. Создайте группу</li>
            <li>Шаг 2. Пригласите бота @{{telegram_bot}} в группу</li>
            <li>Активируйте бота ,написав в группе сообщение:</li>
            <li><blockquote>/addgroup {{ project.secretId}}<br></blockquote></li>
          </ul>





        </div>
        <template slot="footer">
          <base-button type="secondary" @click="modals.modal_integration_telegram = false">Закрыть</base-button>

        </template>
      </modal>
      <modal modal-classes="modal-lg"  :show.sync="modals.add">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">{{ modal_title }}</h5>
        </template>
        <div>
          <div class="alert alert-danger" v-if="iserror==true">
            <p>{{ error_message }}</p>
          </div>

          <div class="form-group row" v-if="type=='developer' && is_add_task">
            <label for="exampleUser">Исполнитель задачи</label>
            <select id="exampleUser" v-if="is_load==true" required v-model="new_task_developer"
                    class="form-control">
              <option value="me">Я</option>

              <option v-if="user.last_id!=me.last_id && user.isapprove==1 && user.role=='spectator'" v-for="user in users"
                      :value="user.last_id"
                      :key="user.last_id">@{{
                  user.name
                }}
              </option>

            </select>


          </div>


        </div>
        <template slot="footer">
          <base-button type="secondary" @click="modals.add = false">Close</base-button>
          <base-button @click="doEditProject" type="primary">Сохранить</base-button>
        </template>
      </modal>
    </card>
  </section>
</template>
<script>

import {eventBus, vm} from "@/main";
import wysiwyg from "vue-wysiwyg";
import Modal from "@/components/Modal";
import axios from "axios";
import Vue from "vue";
import Api from "../models/Api";
import Editorjsrender from "../models/Editorjsrender.vue";
import vueKanban from 'vue-kanban';
import itemTemplate from '@/components/itemTemplate.vue';
import Tabs from "../components/Tabs/Tabs";
import BaseNav from "../components/BaseNav";
import CloseButton from "../components/CloseButton";
import SimpleFlowchart from 'vue-simple-flowchart';
import 'vue-simple-flowchart/dist/vue-flowchart.css';
import itemMapTemplate from '@/components/itemMapTemplate.vue';

var Avatar = require('vue-avatar')


export default {
  data() {
    var app = this;
    return {
      is_load_tasks:false,
      itemTemplate,

      map_current_descr:"",
      map_current_task:null,
      map_items:[],
      map_item:{},
    data_map:{},
      tasks:[],
      filter_tasks_current_status:null,
      "tasks_table": {
        "current_page": 1,
        "on_page": 10,
        "total": 0,
      },
      "filter_tasks":{
        "q":"",

      },
      current_page:"",
      stages: [],
      count_invites:1,
      current_funnel:null,
      statuses:[],
      'fields':{},
      'form':{
        'fields':{},
      },
      funnel:null,
      blocks: [

      ],
      'searchfields':{},
      "funnels": {},
      item: {},
      items: [

      ],


      "invite_user_is_error": false,
      "invite_user_message": null,
      "invite_user": null,
      'modals': {
        'modal0': null,
        'modal_pj_invoices': null,
        'modal_integration_telegram':null,
        'add': null,
        "users": null,
      },

      "project_subcomment": {},
      "subcomment": {},
      "modal_title": "Добавить работу",
      "editProject": {

        'json': null,

      },
      "new_offer_is_error": false,
      "new_offer_error": null,
      "new_comment_is_error": false,
      "new_comment_error": null,
      "newComment": {
        "comment": null
      },

      "newOffer": {
        "last_id": null,
        "price": null,
        "currency": null,
        "date_end": null,
        "comment": null,
      },
      "config": {
        placeholder: 'Распишите задачу как можно подробнее',
        tools: {
          header: require('@editorjs/header'),
          list: {
            class: require('@editorjs/list'),
            inlineToolbar: true,
          },
          "code": require('@editorjs/code'),
          inlineCode: {
            class: require('@editorjs/inline-code'),
            shortcut: 'CMD+SHIFT+M',
          },

          embed: require('@editorjs/embed'),
          linkTool: {
            class: require('@editorjs/link'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/fetchUrl', // Your backend endpoint for url data fetching
            }
          },
          Marker: {
            class: require('@editorjs/marker'),
            shortcut: 'CMD+SHIFT+M',
          },
          table: {
            class: require('@editorjs/table'),
          },
          raw: require('@editorjs/raw'),
          delimiter: require('@editorjs/delimiter'),
          quote: {
            class: require('@editorjs/quote'),
            inlineToolbar: true,
            shortcut: 'CMD+SHIFT+O',
            config: {
              quotePlaceholder: 'Enter a quote',
              captionPlaceholder: 'Quote\'s author',
            },
          },
          image: {
            class: require('@editorjs/image'),
            config: {
              additionalRequestHeaders: {
                "Authorization": 'Bearer ' + app.$store.getters.TOKEN
              },
              endpoints: {
                byFile: Vue.config.API_URL + 'editor/uploadImage', // Your backend file uploader endpoint

              }

            }
          },
          attaches: {
            class: require('@editorjs/attaches'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/uploadFile?api_token=' + app.$store.getters.TOKEN,
            }
          },
          warning: require('@editorjs/warning'),
          paragraph: {
            class: require('@editorjs/paragraph'),
            inlineToolbar: true,
          },
          checklist: {
            class: require('@editorjs/checklist'),
            inlineToolbar: true,
          },
        }
      },

      "lead":null,
      'is_add_task': false,
      'new_invoice_iserror': false,
      'new_invoice_error': null,
      'project_invoices': {},
      'newInvoice': {},
      'type': 'client',
      'image_url': null,
      'base_url':null,
      "telegram_bot":null,
      'iserror': false,
      'error_message': null,
      'users': null,
      'isclose': false,
      'project': {},
      "blog_category":{},
      'is_load': false,
      "offer_btn_edit": "Отправить предложение",

      'me': null,
      "new_task_developer": null,

      "comments": [],
      itemMapTemplate,
    }
  },
  mounted() {
    var app = this;
    let id = app.$route.params.id;

    Api.loadProject(id);





    eventBus.$on("update_project_tasks", data => {
      Api.loadProjectFields({},function(data){

        app.current_page="canban";
        app.is_load=true;
        app.fields=data.fields;
        app.searchfields=data.get_vars;

        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          app.stages=[];
          statuses.forEach((element) => {
            app.stages.push(element.title);
          })
          app.blocks=[];
          statuses.forEach((element) => {
            if(element.projects && element.projects.length>0){
              var projects=element.projects;


              projects.forEach((project) => {

                var new_arr={
                  id: project.last_id,
                  status: element.title,
                  title: project.name_project,
                  project:project,
                }
                app.blocks.push(new_arr);
              })
            }

          })

        }
      },id);

    })
    eventBus.$on("update_project_info", data => {
      app.project.json = data.json;

    })
    eventBus.$on('is_load_project', data => {
      app.current_page="project";
      app.project = data.project;
      if(data.lead){
        app.lead=data.lead;
      }

      app.type = data.role;
      app.is_load = true;
      app.users = data.users;
      app.image_url = Vue.config.IMAGE_URL;
      app.base_url=Vue.config.BASE_URL;
      app.telegram_bot=Vue.config.TG_BOT
      app.me = app.$store.getters.USER;
      if(data.blog_category){

        app.blog_category=data.blog_category;
      }
      if (app.project.edit_offer && app.project.edit_offer.last_id) {
        app.newOffer.comment = app.project.edit_offer.comment;
        app.newOffer.price = app.project.edit_offer.price;
        app.newOffer.currency = app.project.edit_offer.currency;
        app.newOffer.date_end = app.project.edit_offer.date_end;
        app.newOffer.last_id = app.project.edit_offer.last_id;
        app.offer_btn_edit = "Редактировать";
      }

      // if (data.project_invoices == null) {
      //   app.project_invoices = {};
      // } else {
      //   app.project_invoices = data.project_invoices;
      // }
      // app.newComment.project_id = app.project.last_id;
      // if (app.project.isclose == 0) {
      //   app.isclose = false;
      // } else {
      //   app.isclose = true;
      // }


    });
  },
  methods: {

  changeFilterTasks(){
      var app = this;
      var filter={};
      if(Number.isInteger(app.current_status)){
        filter.status=app.filter_tasks_current_status;
      }

      filter.q=app.filter_tasks.q;
      var project_id=app.project.last_id;
      Api.loadTasksWithFilter(filter,project_id,function (data) {
        app.tasks = data.tasks;
        app.is_load_tasks=true;


        app.tasks_table.total = app.tasks.length;
      });

    },
    openCurrentPageProject(){
      var app=this;
      app.current_page="project";
      return false;
    },
    changeManageSpectator(manage_spectator_value=false){
      var app=this;
      var id=app.project.last_id;
      Api.changeManageSpectator(id,manage_spectator_value,function(manage_spectator){

         app.project.manage_spectator=parseInt(manage_spectator);
      },id);

    },
    itemMapSelected (item) {




      var app=this;
      app.map_current_task=item;

    },
    setMapLabel (item) {
      return item.name;
    },
    inputMapChange (text) {
      var app=this;
      // your search method
      app.map_items=[];
      Api.searchTasks(app.project.last_id,text,function(data){
        if(data.tasks.length>0){
          var leads=data.tasks;

          leads.forEach((element) => {
            var name="";
            if(element.name_project){
              name=name+" "+element.name_project;
            }


            name=name+" ["+element.status_row.title+"]";
            var new_element={id:element.last_id,name:name};
            app.map_items.push(new_element);
          })
        }
      });
      // now `items` will be showed in the suggestion list
    },
    openCurrentPageTasks(){
      var app=this;
      var id=app.project.last_id;
      if(app.current_page=="tasks"){
        return false;
      }
      app.current_page="tasks";


      app.changeFilterTasks();
    },
    openCurrentPageMap(){
      var app=this;
      if(app.current_page=="map"){
        return false;
      }
      Api.getMap(app.project.last_id,function(data){

        console.log('current data map');
        console.log(data);
        if(data.map){

          app.data_map=data.map;
          app.current_page="map";
        }
      });


    },
    saveMap(){
      var map=this.data_map;
      var app=this;

      Api.saveMap(app.project.last_id,map,function(data){


        if(data.map){

          app.data_map=data.map;
          app.current_page="map";
        }
      },function(error){

      });
    },
    addTaskOnMap(){

    var current_task=this.map_current_task;
    var current_descr=this.map_current_descr;
    var new_node={};
    new_node.id=current_task.id;
    new_node.x=-700;
    new_node.y=69;
    new_node.type=current_task.name;
    new_node.description=current_descr;
    new_node.label=current_descr;
    var app=this;
    app.data_map.nodes.push(new_node);

    app.map_current_task=null;
    app.map_current_descr="";



    },
    openCurrentPageCanban(){
      var app=this;
      var id=app.project.last_id;
      if(app.current_page=="canban"){
        return false;
      }
      Api.loadProjectFields({},function(data){
        var loaded_vars=data.get_vars;
        var new_vars={};


        Object.keys(loaded_vars).map(function(objectKey, index) {
          var item = loaded_vars[objectKey];
          if(item && item!="null"){
            new_vars[objectKey]=item;
          }else{
            new_vars[objectKey]="";
          }
        });
        app.current_page="canban";
        app.is_load=true;
        app.fields=data.fields;
        app.searchfields=new_vars;

        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          app.stages=[];
          statuses.forEach((element) => {
            app.stages.push(element.title);
          })
          app.blocks=[];
          statuses.forEach((element) => {
            if(element.projects && element.projects.length>0){
              var projects=element.projects;


              projects.forEach((project) => {

                var new_arr={
                  id: project.last_id,
                  status: element.title,
                  title: project.name_project,
                  project:project,
                }
                app.blocks.push(new_arr);
              })
            }

          })

        }
      },id);
    },
    callModelEditLead(lead){
      var app=this;
      var params = {
        "lead_id": lead.id,
        type: "editlead",
        modal_title: "Редактирование лида",
        json:lead.project_data
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    updateBlock(id, status) {
      var app=this;

      var statuses=app.statuses;
      var new_status=null;
      statuses.forEach((element) => {
        if(element.title==status){
          new_status=element;
        }

      })
      if(new_status!=null){
        var app=this;
        var lead_id=id;

        var  json={

          "status_id":new_status.last_id,

        }

        Api.setNewStatus(new_status.last_id, id, function (data) {


          if(data.type=="error"){
            alert(data.message);
          }

        });
      }
      return false;

      //this.blocks.find(b => b.id === Number(id)).status = status;
    },

    itemSelected (item) {
      this.item = item;
      var app=this;
      app.$router.push({name: 'lead', params: {id: item.id, "rand": Math.random()}});
    },
    clickElementMap(){
    alert('clickoff');
    return false;
    },
    setLabel (item) {
      return item.name;
    },
    inputChange (text) {
      var app=this;
      // your search method
      app.items=[];
      Api.searchLead(text,function(data){
        if(data.leads.length>0){
          var leads=data.leads;

          leads.forEach((element) => {
            var name="";
            if(element.lead_data.name){
              name=name+" "+element.lead_data.name;
            }
            if(element.lead_data.phone){
              name=name+" "+element.lead_data.phone;
            }
            if(element.lead_data.email){
              name=name+" "+element.lead_data.email;
            }
            name=name+" "+element.funnel.title+"/"+element.status.title;
            var new_element={id:element.id,name:name};
            app.items.push(new_element);
          })
        }
      });
      // now `items` will be showed in the suggestion list
    },
    callModalAddLead() {
      var app=this;
      var params = {

        type: "addlead",
        islead: true,
        funnel_id:app.current_funnel,

        modal_title: "Добавление лида",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Безымянный проект",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    searchFilter(){
      var app=this;
      var filter=this.searchfields;
      app.is_load=false;



      Api.loadSaveProjectFields(filter,function(data){
        var loaded_vars=data.get_vars;
        var new_vars={};


        Object.keys(loaded_vars).map(function(objectKey, index) {
          var item = loaded_vars[objectKey];
          if(item && item!="null"){
            new_vars[objectKey]=item;
          }else{
            new_vars[objectKey]="";
          }
        });
        app.is_load=true;
        app.stages.length=0;

        app.stages=[];
        app.blocks.length=0;
        app.blocks=[];
        app.statuses.length=0;
        app.statuses=[];
        //     while( app.stages.length > 0) { app.stages.length.pop();}
        //      while( app.blocks.length > 0) { app.blocks.length.pop();}
        //    while( app.statuses.length > 0) { app.statuses.length.pop();}


        app.fields=data.fields;

        app.searchfields=new_vars;


        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          statuses.forEach((element) => {
            app.stages.push(element.title);
          })
          statuses.forEach((element) => {
            if(element.projects && element.projects.length>0){
              var projects=element.projects;

              projects.forEach((project) => {

                var new_arr={
                  id: project.last_id,
                  status: element.title,
                  title: project.name_project,
                  project:project,
                }
                app.blocks.push(new_arr);
              })
            }
          })

        }
      },app.project.last_id)
    },
    openLead(lead_id){
      var app=this;

      let routeData = app.$router.resolve({name: 'lead',params: {id: lead_id, "rand": Math.random()}});
      window.open(routeData.href, '_blank');
    },
    openProject(lead_id){
      var app=this;

      let routeData = app.$router.resolve({name: 'project',params: {id: lead_id, "rand": Math.random()}});
      window.open(routeData.href, '_blank');
    },
    completeInvoice(event, index) {
      event.preventDefault();
      var app = this;
      var id = app.project.invoices[index].last_id;
      var project_id = app.project.last_id;
      Api.completeInvoice(id, project_id, function (data) {

        app.project.invoices = data.project.invoices;
      });
    },
    approveInvoice(event, index) {
      event.preventDefault();
      var app = this;
      var id = app.project.invoices[index].last_id;
      var project_id = app.project.last_id;
      Api.approveInvoice(id, project_id, function (data) {
        app.project.invoices = data.project.invoices;
      });
    },
    deleteSpectator(user_id) {
      var app = this;
      Api.deleteSpectator(app.project.last_id, user_id, function (users) {


        app.users = users;
      }, function (message) {

      });
    },
    deleteInviteLink(invite_id){
     var app=this;
     Api.deleteInviteLink(app.project.last_id,invite_id,function(invites){
       app.project.invites=invites;
     },function(error){

     });
    },
    createInviteLink(){
      var app=this;
      Api.createInviteLinkforProject(app.project.last_id,app.count_invites,function(invites){

        app.project.invites=invites;


      },function(error){

      })
    },
    inviteUser() {
      var app = this;
      Api.addUser(app.project.last_id, app.invite_user, function (users) {

        app.invite_user_is_error = false;
        app.invite_user = null;
        app.users = users;
      }, function (message) {
        app.invite_user_is_error = true;
        app.invite_user_message = message;
      });
    },
    removeInvoice(event, id) {
      event.preventDefault();
      console.log("remove invoice");
      console.log(id);
      var app = this;
      var project_id = app.project.last_id;
      Api.removeInvoice(id, project_id, function (data) {
        console.log('remove invoice');

        app.project.invoices = data.project.invoices;
        // for (var i = app.project.invoices.length - 1; i >= 0; --i) {
        //   if (app.project.invoices[i].last_id == id) {
        //     app.project.invoices = app.project.invoices.splice(i, 1);
        //   }
        // }
        // document.location.reload();
      });

    },
    addTaskClick() {

      var params = {
        "project_id": this.project.last_id,
        "project":this.project,
        type: "addtask",
        type_user: this.type,
        modal_title: "Добавить задачу",
        users: this.users,
        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Название задачи вашей мечты!",
              "level": 2
            }
          }]
        }
      };

      eventBus.$emit("call_modal_add_project", params)
      {


      }


    },
    editProjectShareClick(){
      var app=this;
      var params = {
        "project_id": this.project.last_id,
        'project':this.project,
        type: "edit",
        modal_title: "Редактирование задачи",

        json: this.project.json
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    editProjectClick() {
      var params = {
        "project_id": this.project.last_id,
        'project':this.project,
        type: "edit",
        modal_title: "Редактирование проекта",
        json: this.project.json
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
      // this.$refs.editor._data.state.editor.render(this.project.json);
      // app.is_add_task = false;
      // this.modal_title = "Редактирование проекта";
      // this.modals.add = true;
    },
    ChooseOffer(offer_id) {
      var app = this;
      Api.chooseOfferProject(app.project.last_id, offer_id, function (project) {
        app.$router.replace({"name": "project", "params": {"id": project.last_id, "rand": Math.random()}});
        // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
        vm.$forceUpdate();
      });
    },
    addInvoice() {
      var app = this;
      var project_id = app.project.last_id;
      var newInvoice = app.newInvoice;
      Api.addProjectInvoice(project_id, newInvoice, function (data) {
        app.new_invoice_iserror = false;

        app.newInvoice = {};
        app.project = data.project;
        //eventBus.$emit('is_load_project', data);
        app.modals.modal0 = false;
      }, function (message) {
        app.new_invoice_iserror = true;
        app.new_invoice_error = message;
      })


    },
    doEditProject() {
      var app = this;

      this.$refs.editor._data.state.editor.save()
          .then((data) => {
            // Do what you want with the data here
            var edit_project = {"last_id": app.project.last_id, "json": data};

            if (app.is_add_task == true) {
              edit_project.developer = app.new_task_developer;
              Api.addTask(edit_project, function (tasks) {
                app.iserror = false;

                app.modals.add = false;
                app.is_add_task = false;
                app.project.tasks = tasks;

                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            } else {
              Api.editProject(edit_project, function () {
                app.iserror = false;

                app.modals.add = false;
                app.project.json = edit_project.json;
                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            }

            console.log(data)
          })
          .catch(err => {
            console.log(err)
          })
    },
    sendOfferComment(offer_id, index) {
      var app = this;
      console.log('send comment');
      var comment = app.subcomment['offer' + offer_id];
      Api.sendOfferComment(app.project.last_id, offer_id, comment, function (comments) {
        app.project.offers[index].comments = comments;
        app.subcomment['offer' + offer_id] = "";
      });

    },

    sendOffer() {
      var app = this;
      app.newOffer.project_id = this.project.last_id;
      Api.sendOffer(app.newOffer, function (offer) {
        app.new_invoice_iserror = false;
        if (app.newOffer.last_id == null) {
          app.project.offers = app.project.offers.concat([offer]);
          app.newOffer.last_id = offer.last_id;
        } else {


          const index = app.project.offers.findIndex(item => {
            return (offer.last_id === item.last_id)
          })
          app.project.offers.splice(index, 1, offer)

        }


        app.offer_btn_edit = "Отредактировать";

      }, function (message) {
        app.new_invoice_iserror = true;
        app.new_invoice_error = message;
      })
    },
    sendSubComment(comment_id, comment_index) {
      var app = this;
      console.log('send comment');
      var comment = app.project_subcomment['comment' + comment_id];
      Api.sendSubComment(app.project.last_id, comment_id, comment, function (comments) {
        app.project.comments[comment_index].comments = comments;
        app.project_subcomment['comment' + comment_id] = "";
      });
    },
    openTask(task_id) {

      window.location.hash = "#/project/" + task_id;
      this.$route.params.id = task_id;
      Api.loadProject(task_id);
    },
    setNewStatus() {
      var app = this;
      var status = app.project.status;
      Api.setNewStatus(status, app.project.last_id, function () {

      });
    },
    sendComment(event) {
      event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      Api.addComment(newComment, app.project.last_id, function (result_comment) {
        app.iserror = false;

        app.newComment.comment = "";
        app.project.comments.push(result_comment)
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })


    },
  },
  components: {
    SimpleFlowchart,
    Modal, 'editorjsrender': Editorjsrender,
    'avatar': Avatar.Avatar,
    Tabs,BaseNav,CloseButton
  }
};
</script>
<style>
</style>
